export default __webpack_public_path__ + "static/media/person3.6a13e93c.jpg";